

































































import Vue from "vue";
import Component from "vue-class-component";
import { Chrome } from "vue-color";
import { Prop } from "vue-property-decorator";
import themes from "@/store/modules/themes";

@Component({
  components: {
    "chrome-picker": Chrome
  }
})
export default class ColorPicker extends Vue {
  public popoverShow: boolean = false;
  private colors: any = {};


  @Prop() inputColor: string;
  @Prop() id: any;
  @Prop({ default: true }) useRemove: boolean;
  
  get InputColor() {
    return this.inputColor;
  }

  constructor() {
    super();

    this.colors = {
      hex: this.InputColor,
      a: 1
    };
    //this.initColors();

  }

  mounted() {
    this.$root.$on('bv::popover::hide', bvEventObj => {
      this.initColors();
    })
  }

  initColors() {
    this.colors = {
      hex: this.InputColor,
      a: 1
    };
  }

  onClose() {
    this.initColors();
    this.hidePopover();
  }

  onOk() {
    this.$emit("update-value", this.colors);
    this.hidePopover();
  }

  onRemove() {
    this.$emit("remove-value");
    this.hidePopover();
  }

  hidePopover() {
    this.$root.$emit("bv::hide::popover");
  }
}
